import { useEffect } from 'react';
import ReactModal from 'react-modal';
import { useSbCalls } from '../../../lib/sendbird-calls/SbCallsContext';
import Modal from '../../../templates/Modal';
import { Select, SelectContainer, SelectLabel } from './styles';

const DeviceSettings = (props: ReactModal.Props & { close: () => void; title?: string }) => {
  const sbCalls = useSbCalls();

  useEffect(() => {
    if (props.isOpen) sbCalls.updateMediaDevices({ audio: true, video: true });
  }, []);

  return (
    <Modal
      shouldCloseOnOverlayClick
      title="Settings"
      content={
        <>
          <SelectContainer>
            <SelectLabel htmlFor="camera-select">Camera</SelectLabel>
            <Select
              id="camera-select"
              defaultValue={sbCalls.videoInputDeviceInfo.current?.deviceId}
              onChange={(e) => {
                const { value } = e.target;
                const mediaInfo = sbCalls.videoInputDeviceInfo.available.find(
                  (device) => device.deviceId === value
                );
                if (mediaInfo) sbCalls.selectVideoInputDevice(mediaInfo);
              }}
            >
              {sbCalls.videoInputDeviceInfo.available.map((info) => (
                <option key={info.deviceId} value={info.deviceId}>
                  {info.label}
                </option>
              ))}
            </Select>
          </SelectContainer>

          <SelectContainer>
            <SelectLabel htmlFor="microphone-select">Microphone</SelectLabel>
            <Select
              id="microphone-select"
              defaultValue={sbCalls.audioInputDeviceInfo.current?.deviceId}
              onChange={(e) => {
                const { value } = e.target;
                const mediaInfo = sbCalls.audioInputDeviceInfo.available.find(
                  (device) => device.deviceId === value
                );
                if (mediaInfo) sbCalls.selectAudioInputDevice(mediaInfo);
              }}
            >
              {sbCalls.audioInputDeviceInfo.available.map((info) => (
                <option key={info.deviceId} value={info.deviceId}>
                  {info.label}
                </option>
              ))}
            </Select>
          </SelectContainer>

          <SelectContainer>
            <SelectLabel htmlFor="speaker-select">Speaker</SelectLabel>
            <Select
              id="speaker-select"
              defaultValue={sbCalls.audioOutputDeviceInfo.current?.deviceId}
              onChange={(e) => {
                const { value } = e.target;
                const mediaInfo = sbCalls.audioOutputDeviceInfo.available.find(
                  (device) => device.deviceId === value
                );
                if (mediaInfo) sbCalls.selectAudioOutputDevice(mediaInfo);
              }}
            >
              {sbCalls.audioOutputDeviceInfo.available.map((info) => (
                <option key={info.deviceId} value={info.deviceId}>
                  {info.label}
                </option>
              ))}
            </Select>
          </SelectContainer>
        </>
      }
      footer={{}}
      {...props}
    />
  );
};

export default DeviceSettings;
